import { Box } from "@mui/material";
import React from "react";
/**
 * The Header is absolutely positioned
 * This provides a corresponding offset/padding
 */
export const HeaderOffset = () => (React.createElement(Box, { id: "header-offset", sx: { width: "100%", height: { xs: "0px", sm: "0px", md: "100px" } } }));
//# sourceMappingURL=header-offset.js.map